<template>
  <div v-if="countriesAll.length">
    <div v-if='!showThankyouMessage'>
      <div class="rounded bg-white p-6 shadow-md">
        <p class="text-3xl font-extrabold">Order</p>
        <div class="flex flex-col md:flex-row md:justify-between gap-6 mt-6 w-full">
          <div class="flex flex-col">
            <span class="font-bold">To:</span>
            <span>{{ companyProfile.companyName }}</span>
            <span>{{ attendees[0].name }}</span>
            <span>{{ attendees[0].email }}</span>
            <span>{{ companyProfile.streetAddress }}</span>
            <span>{{ companyProfile.countryName }}</span>
          </div>

          <div class="flex flex-col">
            <span class="font-bold">From:</span>
            <span>The Broker Site BV</span>
            <span>Ginnekenweg 272</span>
            <span>4835 NK Breda</span>
            <span>The Netherlands</span>
          </div>
        </div>

        <!-- Desktop -->
        <div class="hidden md:block mt-6 overflow-hidden rounded-lg border border-gray-200 bg-gray-100">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-700">
              <tr class="py-1">
                <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Quantity
                </th>
                <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Description
                </th>
                <th class="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Price
                </th>
              </tr>
            </thead>
            <tbody class=" ">
              <tr v-for="(lineItem, index) in lineItems" :key="index" :class="lineItem.cssClass" class="!py-6">
                <td v-if="index === 0" :rowspan="rowspan">
                  <span class="p-4">1</span>
                </td>
                <td :colspan="index > rowspan - 1 ? 2 : 1" class="py-1 pl-4 pr-3 text-sm text-gray-500" :class="[
                  lineItem.labelClass,
                  lineItem.name === 'Subtotal' ? 'pt-6' : 'py-1'
                ]">
                  {{ lineItem.name }}
                </td>
                <td class="relative whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium" :class="[
                  lineItem.name === 'Subtotal' ? 'pt-6' : 'py-1'
                ]">{{ lineItem.amount == -1 ? '' : lineItem.amountString }}
                </td>
              </tr>
            </tbody>
          </table>

        </div>

        <!-- Mobile -->
        <!-- Mobile -->
        <!-- Mobile -->
        <div class="md:hidden mt-6 overflow-hidden rounded-lg border border-gray-200">
          <div class="grid grid-cols-2 bg-gray-700 text-xs font-semibold uppercase text-white">
            <div class="px-4 py-3">Description</div>
            <div class="px-4 py-3 text-right">Price</div>
          </div>

          <div v-for="(lineItem, index) in lineItems" :key="index" class="grid grid-cols-2 ">
            <div class="px-4 text-sm text-gray-500" :class="[
              lineItem.labelClass,
              lineItem.name === 'Subtotal' ? 'pt-6 pb-2 border-t border-gray-400' : 'py-2'
            ]">
              {{ lineItem.name }}
            </div>

            <div class="px-4 text-right text-sm font-medium" :class="[
              lineItem.name === 'Subtotal' ? 'pt-6 pb-2 border-t border-gray-400' : 'py-2'
            ]">
              {{ lineItem.amount == -1 ? '' : lineItem.amountString }}
            </div>
          </div>
        </div>

        <div class="flex flex-col space-y-0 text-sm mt-3 bg-gray-100 p-4 rounded">
          <span class="text-red-500 font-bold">Cancellation Policy:</span>
          <span class="">Full refund till end of June</span>
          <span class="">50% refund till end of August</span>
          <span class="">No refunds after September 1st</span>
        </div>

      </div>



      <!-- <div class="m-auto mb-8">
        <table class="min-w-full divide-y divide-gray-300 border-b border-b-gray-200">
          <thead>
            <tr>
              <th scope="col" colspan="2"
                class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">Payment
                Overview
              </th>
            </tr>
          </thead>
          <tbody class="bg-white ">
            <tr v-for="(lineItem, index) in lineItems" :key="index" :class="lineItem.cssClass">
              <td class="py-2 pl-4 pr-3 text-sm text-gray-500" :class="lineItem.labelClass">{{ lineItem.name }}
              </td>
              <td class="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium">{{
                lineItem.amountString }}
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->

      <div v-if='!!companyProfile.tbsCompanyId' class="m-auto font-bold">
        <p class="my-6 text-sm text-gray-700 text-center">
          We use Mollie as our secure payment provider, supporting all major payment methods. Once your payment has been
          successfully processed, your EBM account will be activated immediately, and your invoice will be sent to you
          by email.
        </p>
        <!-- <ul role="list" class="grid grid-cols-3 gap-2 sm:grid-cols-5 ">
          <li v-for='item in paymentProviders' :key='item.imgUrl'
            class="col-span-1 divide-y divide-gray-200 rounded-sm bg-white shadow p-2" :title="item.alt">
            <div class='paymentIcon bg-no-repeat bg-contain bg-center' :style="{ backgroundImage: `url(${item.imgUrl})` }">
            </div>
          </li>
        </ul>
        <p class="my-6 text-sm leading-5 text-gray-600">Upon completion of the order, your credit card will be charged
          immediately.</p> -->
      </div>

      <div class="pt-5">
        <div class="flex justify-end">
          <button @click='prev' type="button"
            class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">{{
              prevButtonLabel }}</button>
          <button @click='next' type="button"
            class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">Pay</button>
        </div>
      </div>
    </div>
    <div v-else>
      <span v-html="regThankyouText"></span>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions } from 'vuex';

import eventBus from "../utils/eventBus";
import payVisa from "../assets/pay/pay_visa.png"
import payAmex from "../assets/pay/pay_amex.png"
import payMc from "../assets/pay/pay_mc.png"
import payBancontact from "../assets/pay/pay_bancontact.png"
import payMaestro from "../assets/pay/pay_maestro.png"
import payIdeal from "../assets/pay/pay_ideal.png"
import payGiropay from "../assets/pay/pay_giropay.png"
import payBelfius from "../assets/pay/pay_belfius.png"
import payKbc from "../assets/pay/pay_kbc.png"
import payCbc from "../assets/pay/pay_cbc.png"
import paySofosDe from "../assets/pay/pay_sofos_de.png"
import paySofosAt from "../assets/pay/pay_sofos_at.png"
import paySofosNl from "../assets/pay/pay_sofos_nl.png"
import paySofosBe from "../assets/pay/pay_sofos_be.png"
import paySofosIt from "../assets/pay/pay_sofos_it.png"

export default {
  name: "RegisterStep2",
  props: {
    companyProfile: Object,
    attendees: Array,
  },

  data() {
    return {
      paymentProviders: [
        { imgUrl: payVisa, alt: 'VISA' },
        { imgUrl: payAmex, alt: 'American Express' },
        { imgUrl: payMc, alt: 'MasterCard' },
        { imgUrl: payBancontact, alt: 'Bancontact/Mister Cash' },
        { imgUrl: payMaestro, alt: 'Maestro' },
        { imgUrl: payIdeal, alt: 'iDEAL' },
        { imgUrl: payGiropay, alt: 'giropay' },
        { imgUrl: payBelfius, alt: 'Belfius Direct Net' },
        { imgUrl: payKbc, alt: 'KBC Bank' },
        { imgUrl: payCbc, alt: 'CBC Banque' },
        { imgUrl: paySofosDe, alt: 'Sofortï¿½berweisung DE' },
        { imgUrl: paySofosAt, alt: 'Sofortï¿½berweisung AT' },
        { imgUrl: paySofosNl, alt: 'Sofort Banking NL' },
        { imgUrl: paySofosBe, alt: 'Sofort Banking BE' },
        { imgUrl: paySofosIt, alt: 'Sofort Banking IT' },
      ],
      prices: {
        membership: 725,
        attendence: 1095,
      },
      showThankyouMessage: false,
      regThankyouText: null,
    };
  },
  computed: {
    ...mapState(['countriesAll', 'withTBSMembership']),
    lineItems() {
      const items = []
      if (!this.companyProfile.tbsCompanyId) {
        items.push({
          name: 'TBS Plus Membership (1 year)',
          amount: this.prices.membership,
        })
      }
      _.each(this.attendees, attendee => {
        items.push({
          name: `EBM Attendance for ${attendee.name} (${attendee.email})`,
          amount: this.prices.attendence,
        })
      })

      let vat = 0
      let vatDescription = 'VAT Total'

      const nl = _.find(this.countriesAll, { country: 'Netherlands' }).country_id
      const reverseChargeCountryCodes = _.map(_.filter(this.countriesAll, { reverse_charge: 1 }), 'country_id')

      if (this.companyProfile.country === nl) {
        vat = 21
        vatDescription = 'VAT Total (21% VAT)'
      } else if (~reverseChargeCountryCodes.indexOf(this.companyProfile.country)) {
        vatDescription = 'VAT Total (Reverse Charge)'
      }

      const subTotal = _.sumBy(items, 'amount')
      const vatTotal = subTotal * (vat / 100)
      const grandTotal = subTotal + vatTotal

      items.push({ name: 'Subtotal', amount: subTotal, cssClass: "border-t border-t-gray-200 pt-6", labelClass: "font-bold" })
      items.push({ name: 'VAT Number: ' + this.companyProfile.vat, amount: -1, labelClass: "font-bold" })
      items.push({ name: vatDescription, amount: vatTotal, labelClass: "font-bold" })
      items.push({ name: 'Total', amount: grandTotal, cssClass: "border-double border-t-4 border-t-gray-200", labelClass: "font-bold py-2" })

      _.each(items, item => {
        item.amountString = `€ ${item.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      })
      return items
    },

    rowspan() {
      return this.attendees.length + (this.companyProfile.tbsCompanyId ? 0 : 1)
    },

    prevButtonLabel() {
      return this.payload.tbsCompanyId ? "Back" : "Back to Attendees";
    },
  },
  async created() {
    this.payload = _.cloneDeep(this.companyProfile)

    try {
      this.allSettings = await this.$http.get("/api/misc/allSettings").then(res => res.data.payload)
      this.regThankyouText = this.allSettings.reg_thankyou
    } catch (err) {
      console.log("err", err)
    }
  },
  methods: {
    ...mapActions(["register"]),
    async next() {

      // let dlPushAction = 'Registration INITIATED'
      // let pushMessage = this.companyProfile.tbsCompanyId ? 'Registration by a TBS Member' : 'Registration by a non-member';
      // this.pushDataLayer('ebmRegStart', 'buttRegister', dlPushAction, pushMessage)

      const payload = {
        companyProfile: this.companyProfile,
        attendees: this.attendees,
        utmParams: localStorage.getItem('utmParams'),
        refParams: localStorage.getItem('refParams'),
      }

      try {
        // Register
        const response = await this.register(payload)
        // registration is complete, we need to push to the Google tag manager
        let dlPushAction = 'Registration COMPLETED'
        let pushMessage = this.companyProfile.tbsCompanyId ? 'Registration by a TBS Member' : 'Registration by a non-member';
        this.pushDataLayer('ebmRegEnd', 'buttRegister', dlPushAction, pushMessage)

        // For Google Analytics
        this.$store.dispatch('trackGA4Event', {
          event: 'registration_completed',
          event_category: 'User Interaction',
          event_label: 'Registration Completed',
          action: 'clicked',
          heardThrough: this.companyProfile.heardThrough,
          withTBSMembership: this.withTBSMembership,
          message: `Registration Completed`,
        });

        // When all good, redirect to payment
        // only redirect to payment if this is a TBS member, non-TBS members will not be redirected but shown the thank you page
        if (this.companyProfile.tbsCompanyId) { window.location.href = response.link }
        else { this.showThankyouMessage = true }

      } catch (err) {
        let dlPushAction = 'Registration Incomplete (failed)'
        let pushMessage = this.companyProfile.tbsCompanyId ? 'Registration by a TBS Member' : 'Registration by a non-member';
        this.pushDataLayer('ebmRegError', 'buttRegister', dlPushAction, pushMessage)

        this.showThankyouMessage = false
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Error while registering",
          body: err.message,
          timeoutInMS: 5000,
        });

        // For Google Analytics
        this.$store.dispatch('trackGA4Event', {
          event: 'registration_failed',
          event_category: 'User Interaction',
          event_label: 'Registration Failed',
          action: 'clicked',
          heardThrough: this.companyProfile.heardThrough,
          withTBSMembership: this.withTBSMembership,
          message: `Registration Failed: ${err?.message || 'Unknown error'}`,
        });
      }

    },
    async prev() {
      if (this.payload.tbsCompanyId) {
        this.$parent.$parent.toStep({ step: 2, companyProfile: this.payload })
      } else {
        this.$parent.$parent.toStep({ step: 4, companyProfile: this.payload })
      }
    },
    pushDataLayer(event, buttonId, action, message) {
      window.dataLayer.push({
        'event': event, // A custom event name, e.g., 'signupButtonClick'
        'buttonId': buttonId, // Optional: ID or any identifier of the button
        'action': action, // Optional: More details about the action
        'message': message,
        // You can add more properties here as needed
      })
    },
  },

};
</script>
<style>
.paymentIcon {
  height: 45px
}
</style>
